import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTIONS_QUERY_KEY } from './useGetMerchandisingCollections';

import MerchandisingCollectionsService, {
  CreateMerchandisingCollectionDto,
} from '@/services/MerchandisingCollectionsService';

export function useCreateMerchandisingCollection() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (dto: CreateMerchandisingCollectionDto) =>
      MerchandisingCollectionsService.createCollection(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTIONS_QUERY_KEY,
      });
    },
  });

  return {
    createMerchandisingCollection: mutateAsync,
    isLoading: isPending,
  };
}
